export default __webpack_public_path__ + "static/media/ongirdsystem.7d543486.jpg";